const SET_LOADING = async (state, payload) => {
  state.loading = payload
}

const SET_DESATUALIZADO = (state, payload) => {
  state.desatualizado = payload
}

const UPDATE_BLACKLIST = (state, payload) => {
  state.dados.blacklist = payload.blacklist
  state.dados.whitelist = payload.whitelist
  state.dados.histogram = payload.histogram
}

export { SET_LOADING, SET_DESATUALIZADO, UPDATE_BLACKLIST }
